import { LOCATION_CHANGE } from 'connected-react-router';
// External Imports
import compose from 'lodash/fp/flow.js';
import set from 'lodash/fp/set.js';

// Internal Imports
import {
  RECEIVE_ERROR,
  RECEIVE_PRIMARY_CONTENT,
  RECEIVE_SITE_OPTIONS,
  REQUEST_ARCHIVE,
  REQUEST_CONTENT_ITEM,
  REQUEST_NEXT_PAGE,
  REQUEST_NEXT_PAGE_FETCH_INITIATED,
  REQUEST_SEARCH,
  REQUEST_SITE_OPTIONS,
} from '../config/types/action.mjs';
import { NotFoundError } from '../errors/notFoundError.mjs';
import { selectActivePagination } from '../selectors/selectActivePagination.mjs';
import { selectMatch } from '../selectors/selectMatch.mjs';

// Local Functions
/**
 * Root reducer for global state values.
 * @param {object}   state   state container
 * @param {string}   type
 * @param {*}        payload
 * @returns {object}
 */
function activeReducer(state = {}, { payload, type } = {}) {
  switch (type) {
    case LOCATION_CHANGE: {
      const {
        params: { page },
      } = selectMatch(state);
      return set('active.pagination.currentPage', page ? Number.parseInt(page, 10) : 1, state);
    }

    case RECEIVE_ERROR:
      return payload instanceof NotFoundError
        ? set('active.notFound', true, state)
        : set('active.error', payload, state);

    case RECEIVE_PRIMARY_CONTENT:
      return compose(
        set('active.loading.content', false),
        set('active.loading.more', false),
      )(state);

    case RECEIVE_SITE_OPTIONS:
      return set('active.loading.siteData', false, state);

    case REQUEST_ARCHIVE:
    case REQUEST_CONTENT_ITEM:
    case REQUEST_SEARCH:
      return set('active.loading.content', true, state);
    case REQUEST_NEXT_PAGE: {
      const pagination = selectActivePagination(state);
      const { currentPage, totalPages } = pagination;
      const nextPage = currentPage + 1;
      const newCurrentPage = nextPage <= totalPages ? nextPage : currentPage;
      return set('active.pagination.currentPage', newCurrentPage, state);
    }

    case REQUEST_NEXT_PAGE_FETCH_INITIATED:
      return set('active.loading.more', true, state);

    case REQUEST_SITE_OPTIONS:
      return set('active.loading.siteData', true, state);

    default:
      return state;
  }
}

// Module Exports
export { activeReducer };
